export enum MemoTabChoices {
  CONTENT_EDITOR = "content_editor",
  SAVED_PDFS = "saved_pdfs",
}

export const TABS: Array<{
  label: string;
  value: MemoTabChoices;
}> = [
  { label: "Content editor", value: MemoTabChoices.CONTENT_EDITOR },
  { label: "Saved PDFs", value: MemoTabChoices.SAVED_PDFS },
];
